import genericApi from './genericApi';

import Login from '../models/Login';
import User from '../models/User';
import ApiResponse from '../models/ApiResponse';
import RegisterModel from '../models/Register';

const userReqHandler = {

	login: (loginObj: Login): Promise<ApiResponse<User>> => {
		return genericApi.post('login', loginObj);
	},
	logout: (): Promise<ApiResponse<boolean>> => {
		return genericApi.post('logout');
	},
	register: (data: RegisterModel): Promise<ApiResponse<boolean>> => {
		return genericApi.put('register', data);
	},

	getUuid: (data: any): Promise<ApiResponse<string>> => {
		return genericApi.put('send_user_details', data);
	},
};

export default userReqHandler;